<ng-container *ngIf="notificationsTop$ | async as notificationsTop">
  <div *ngIf="notificationsTop.length" class="pr-xsmall-b">
    <fin-mmb-notifications [notifications]="notificationsTop"></fin-mmb-notifications>
  </div>
</ng-container>

<fcom-trip-card
  class="block white-bg mr-large-b"
  *ngIf="booking$ | async as booking"
  [title]="booking.bounds.length > 2 ? ('multiCity.flightSelection.title' | finLocalization) : null"
  [destinations]="summary$ | async"
  [departureDate]="departureDate$ | async | finDateFormat: 'DATE'"
  [arrivalDate]="arrivalDate$ | async | finDateFormat: 'DATE'"
  [passengerAmount]="booking.passengers.length"
  [bookingRef]="booking.id"
  [image]="image$ | async"
  [expanded]="true"
  [operatingAirlineIds]="booking.operatingAirlineIds"
>
  <ng-container *ngIf="notifications$ | async as notifications">
    <fin-mmb-notifications
      *ngIf="notifications.length > 0"
      class="pr-xsmall"
      [notifications]="notifications"
    ></fin-mmb-notifications>
  </ng-container>
  <div
    *ngFor="let bound of booking.bounds; index as i; first as isFirst; last as isLast; trackBy: trackByFn"
    class="bound-group"
  >
    <fin-mmb-flight
      [order]="booking"
      [bound]="bound"
      [locations]="booking.locations"
      [isComplexJourney]="(summary$ | async)?.length > 3"
      [type]="isFirst ? BoundType.outbound : isLast ? BoundType.inbound : null"
      (emailModalOpen)="this.emailModalOpen.emit(true)"
      (upsellClicked)="upsellClicked.emit($event)"
    ></fin-mmb-flight>
    <fin-mmb-third-party-links
      *ngIf="isFirst && (isWithin24HoursOfCreation$ | async) === false"
      [order]="booking"
      [arriving]="booking.bounds[0].arrival"
      [leaving]="booking.bounds.length > 1 ? booking.bounds[booking.bounds.length - 1]?.departure : null"
      [partnerEligibilities]="partnerEligibilities$ | async"
    ></fin-mmb-third-party-links>
  </div>
</fcom-trip-card>

@if (enableHotelsMMB && (partnerEligibilities$ | finMap: ThirdPartyAncillariesProvider.EXPEDIA_HOTEL | async)) {
  <fin-mmb-hotels-widget
    [order$]="booking$"
    [isWithin24HoursOfCreation]="isWithin24HoursOfCreation$ | async"
  ></fin-mmb-hotels-widget>
}

<fin-cartrawler-widget
  *ngIf="
    (isWithin24HoursOfCreation$ | async) === true &&
    (partnerEligibilities$ | finMap: ThirdPartyAncillariesProvider.CAR_TRAWLER_RENTAL | async)
  "
  [clientId]="carTrawlerClientId"
  [order]="booking$ | async"
></fin-cartrawler-widget>

<fin-mmb-modify-trip
  *ngIf="bookingHasNoDisruption$ | async"
  [booking$]="booking$"
  [changeFlightModalOpen$]="changeFlightModalOpen$"
  [showTravelExtrasButton]="showTravelExtrasButton"
  (emailModalOpen)="openEmailModal($event)"
  (scrollToTravelExtras)="scrollToTravelExtrasContent()"
></fin-mmb-modify-trip>
